import React, { Component } from 'react'

class SignIn extends Component{
  constructor(){
    super();
    this.state = {
      email: '',
      password: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }



  handleSubmit(event) {
    event.preventDefault()
    const username = this.state.email
    const password = this.state.password
    let headers = { "Content-Type": "application/json",};
    let body = JSON.stringify({username, password});
    return fetch("/api/auth/get-token",
      {
        headers,
        body,
        method: "POST",
      })
      .then(res => {
        if (res.status === 200) {
          return res.json().then(data => {
            localStorage.setItem("admin-token", data.token);
            this.props.toggleAuthenticate()
            this.props.history.push('/backoffice/months')
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render() {
    return(
      <div className="Admin-SignIn">
        <p className="Admin-SignIn-title">Backoffice</p>
        <form onSubmit={this.handleSubmit} className="Admin-SignIn-form">
          <h1>Sign In</h1>
          <label>Email</label>
          <input
            name="email"
            autoComplete="email"
            onChange={this.handleChange}
            type="email"
            placeholder="email" />
          <label>Password</label>
          <input
            name="password"
            autoComplete="current-password"
            onChange={this.handleChange}
            type="password"
            placeholder="password" />
          <button>Sign in</button>
        </form>
      </div>
    )
  }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/containers/admin/containers/SignIn.jsx